import axios from 'axios';
import * as R from 'ramda';
import auth0Client from 'js/creator_auth0_client';
import {removeAuth0Storage} from 'js/auth0_storage';

/**
 * @param {Function} req An axios request to await which may require the user be logged in
 */
async function userRequest(req) {
    try {
        return await req();
    } catch (e) {
        if (e.status === 403) {
            return null;
        }

        throw e;
    }
}

/** @todo move this to API's creatorDashboardService */
function reorderInvites(campaignInvites) {
    const open = R.sortBy(
        R.prop('flight_start'),
        R.filter(R.whereEq({has_started: true, has_ended: false}), campaignInvites)
    );

    const notStarted = R.filter(R.whereEq({has_started: false, has_ended: false}), campaignInvites);

    const closed = R.filter(R.whereEq({has_started: true, has_ended: true}), campaignInvites);

    return [...open, ...notStarted, ...closed];
}

export async function createSignUpRequest(data) {
    const response = await axios.post('/api/createSignUpRequest', data);
    return response.data;
}

export async function requestSignUpRequestConfirmationEmail(signUpRequestId) {
    const response = await axios.get(
        `/api/requestSignUpRequestEmailConfirmation/${signUpRequestId}`
    );
    return response.data;
}

export async function getUser() {
    const response = await userRequest(() => axios.get('/api/currentUser'));
    return R.propOr(null, 'data', response);
}

export async function getLoggedIn() {
    const response = await userRequest(() => axios.get('/api/currentUserIsAuthenticated'));
    return R.propOr(false, 'data', response);
}

export async function getCampaignInvites() {
    const response = await userRequest(() => axios.get('/api/invites'));

    if (R.isNil(response)) {
        return {
            active: [],
            extended: [],
            full: [],
            expired: [],
            rejected: [],
            failed_smart_questions: []
        };
    }

    const {active, extended, full, expired, rejected, failed_smart_questions} = response.data;

    return {
        active: reorderInvites(active),
        extended,
        full,
        expired,
        rejected,
        failed_smart_questions
    };
}

export async function getRecentlyEndedCampaigns() {
    const response = await userRequest(() =>
        axios.get('/creator/dashboard/campaigns/recently_ended_campaigns')
    );

    if (R.isNil(response)) return [];

    return response.data;
}

export async function getUpcomingCampaigns() {
    const response = await axios.get('/creator/dashboard/campaigns/upcoming');
    return response.data.campaigns;
}

export async function getFlightsForCampaign(campaignId) {
    const response = await axios.get(`/creator/dashboard/campaigns/${campaignId}/flights`);

    return response.data;
}

export async function getNumberOfCompletedCampaigns() {
    const response = await axios.get('/creator/dashboard/campaigns/completed');
    return response.data;
}

export async function requestInviteToCampaignV2(campaignId, flightId) {
    const response = await axios.post('/creator/dashboard/request_invite', {
        campaign_id: campaignId,
        flight_id: flightId
    });

    return response.data;
}

export async function updateProfile(profile) {
    const response = await axios.put('/api/currentUser', profile);
    return response.data;
}

export async function getInstagramPosts(inviteId) {
    const response = await axios.get(`/api/invites/${inviteId}/instagramPosts`);
    return response.data;
}

export async function getSubmissions(inviteId) {
    const response = await axios.get(`/api/invites/${inviteId}/submissions`);
    return response.data;
}

export async function submitInstagramPost(inviteId, postId) {
    const response = await axios.post(`/api/invites/${inviteId}/submitInstagramPost`, {
        post_id: postId
    });
    return response.data;
}

export async function submitYoutubeVideo(inviteId, videoUrl) {
    const response = await axios.post(`/api/invites/${inviteId}/submitYoutubeVideo`, videoUrl);
    return response.data;
}

export async function submitForContentApproval(inviteId, contentType, data) {
    const response = await axios.post(`/api/invites/${inviteId}/submitGenericContent`, {
        contentType,
        data
    });
    return response.data;
}

export async function pingContentApprovalPreviewUrl(inviteId, data) {
    const response = await axios.post(
        `/api/invites/${inviteId}/pingGenericContentPreviewUrl`,
        data
    );
    return response.data;
}

export async function submitGenericContentForReview(inviteId, contentMetadataId, data) {
    const response = await axios.post(
        `/api/invites/${inviteId}/submitGenericContentForReview/${contentMetadataId}`,
        data
    );
    return response.data;
}

export async function submitSmartQuestionsAnswers(campaignId, data) {
    const response = await axios.post(
        `/creator/dashboard/campaigns/${campaignId}/submit_smart_questions_answers`,
        data
    );

    return response.data;
}

export async function applyForExtension(inviteId) {
    const response = await axios.get(`/api/invites/${inviteId}/applyForExtension`);
    return response.data;
}



// WEBPACK FOOTER //
// ./creator/dashboard/dashboard_api_client.js